import { AppRoutes } from '@bn/dashboard-core/enums';
import { MenuItem } from '@bn/layout';

export const mobileMenuConfig: MenuItem[] = [
  {
    name: 'Overview',
    icon: ['fad', 'house-blank'],
    route: AppRoutes.Overview,
  },
  {
    name: 'Statistics',
    icon: ['fad', 'chart-simple'],
    route: AppRoutes.Statistics,
  },
  {
    name: 'Account',
    icon: 'circle-user',
    route: AppRoutes.Account,
  },
  {
    name: 'Support',
    icon: ['fad', 'life-ring'],
    route: AppRoutes.Support,
  },
  {
    name: 'Menu',
    icon: 'bars',
    action: 'toggle-menu',
  },
];
